import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const {
    palette: { secondary }
  } = theme;

  return {
    root: {
      width: 26,
      height: 16,
      padding: 0,
      display: "flex"
    },
    switchBase: {
      padding: 2,
      color: theme.palette.grey[500],
      "&$checked": {
        transform: "translateX(10px)",
        color: "#fff",
        "& + $track": {
          opacity: 1,
          backgroundColor: secondary.dark,
          borderColor: secondary.dark
        }
      }
    },
    thumb: {
      width: 12,
      height: 12,
      boxShadow: "none"
    },
    track: {
      border: `1px solid ${theme.palette.grey[500]}`,
      borderRadius: 8,
      opacity: 1,
      backgroundColor: "#fff"
    },
    toggleTitle: {
      fontSize: 12,
      cursor: "pointer",
      "&.disabled": {
        cursor: "default"
      }
    },
    checked: {}
  };
});
